import dayjs from "dayjs";

/**
 * Get the last day of the month from 2 months ago
 * e.g., if today is January 2026, returns 2025-11-30 (November 30, 2025)
 */
export const getLastCompletedMonthDate = (): string => {
    const now = dayjs();
    const twoMonthsAgo = now.subtract(2, "month");
    const lastDayOfMonth = twoMonthsAgo.endOf("month");
    return lastDayOfMonth.format("YYYY-MM-DD");
};
